<form>
  <mat-form-field >
    <mat-label>Lo que deseas, esta en tuGessi.com</mat-label>
    <input matInput placeholder="Ejem. Tecnología...">
  </mat-form-field>
</form>

<mat-autocomplete #autoProduct="matAutocomplete">
  <mat-option>
    <span>Producto 1</span>
  </mat-option>
  <mat-option>
    <span>Producto 2</span>
  </mat-option>
</mat-autocomplete>
